import { StreamingChunkPayload } from '@wix/wix-help-widget-common/duplexer';
import { Store } from 'redux';

import { TRootState } from '../common/reducers';
import { chatActions } from '../common/reducers/chat';

const isStaleConversationEvent = (store: Store<TRootState>, eventConversationId?: string): boolean => {
  const localConversationId = store.getState().chat.conversationId;
  return !!localConversationId && !!eventConversationId && eventConversationId !== localConversationId;
};

export const createStreamingEventHandlers = (store: Store<TRootState>) => {
  const onStreamingChunk = (data: StreamingChunkPayload): void => {
    const { messageId, accumulatedText, sequenceNumber, done, conversationId } = data;
    if (isStaleConversationEvent(store, conversationId)) {
      return;
    }
    if (done && !accumulatedText) {
      store.dispatch(chatActions.cancelStreamingMessage({ messageId }));
    } else {
      store.dispatch(chatActions.updateStreamingChunk({ messageId, accumulatedText, sequenceNumber }));
    }
  };

  return { onStreamingChunk };
};
